import { Link } from 'react-router-dom';
import { topRankedMovies } from '@/mocks/movies';

export default function MovieRanking() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
              热播排行榜
            </h2>
            <p className="text-sm text-foreground-500 mt-1">评分最高的十部电影推荐</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topRankedMovies.slice(0, 9).map((movie, index) => (
            <Link
              key={movie.id}
              to={`/movie/${movie.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-100/80 border border-background-200/60 cursor-pointer hover:border-primary-500/40 hover:bg-background-200/50 transition-all duration-200"
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-200 border border-background-300/50">
                {index < 3 ? (
                  <i className={`text-base ${index === 0 ? 'ri-medal-fill text-primary-500' : index === 1 ? 'ri-medal-fill text-secondary-500' : 'ri-medal-fill text-accent-500'}`}></i>
                ) : (
                  <span className="text-sm font-bold text-foreground-500">{index + 1}</span>
                )}
              </div>

              <div className="flex-shrink-0 w-16 h-20 rounded-md overflow-hidden">
                <img
                  src={movie.coverImage}
                  alt={movie.title}
                  title={`${movie.title} - 星空影院排行榜第${index + 1}名`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors truncate">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">{movie.englishTitle}</p>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="text-xs text-foreground-600 whitespace-nowrap">{movie.year}</span>
                  <div className="flex items-center gap-0.5">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                    </div>
                    <span className="text-xs font-semibold text-accent-400 whitespace-nowrap">{movie.rating}</span>
                  </div>
                </div>
              </div>

              <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-primary-500 text-xl"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}